import { MagentoSalesOrderItems } from './magento-sales-order-items';
import { MagentoSalesOrderStatusHistory } from './magento-sales-order-status-history';
import { MagentoSalesOrderItemValues } from './magento-sales-order-item-values';

export interface MagentoSalesOrder {
  base_currency_code: string;
  base_discount_amount: number;
  base_grand_total: number;
  base_discount_tax_compensation_amount: number;
  base_shipping_amount: number;
  base_shipping_discount_amount: number;
  base_shipping_discount_tax_compensation_amnt: number;
  base_shipping_incl_tax: number;
  base_shipping_tax_amount: number;
  base_subtotal: number;
  base_subtotal_incl_tax: number;
  base_tax_amount: number;
  base_total_due: number;
  base_to_global_rate: number;
  base_to_order_rate: number;
  billing_address_id: number;
  created_at: string;
  customer_email: string;
  customer_group_id: string;
  customer_is_guest: string;
  customer_note_notify: string;
  discount_amount: number;
  email_sent: string;
  entity_id: number;
  global_currency_code: string;
  grand_total: number;
  discount_tax_compensation_amount: number;
  increment_id: string;
  is_virtual: number;
  order_currency_code: string;
  protect_code: string;
  quote_id: number;
  remote_ip: string;
  shipping_amount: number;
  shipping_description: string;
  shipping_discount_amount: number;
  shipping_discount_tax_compensation_amount: number;
  shipping_incl_tax: number;
  shipping_tax_amount: number;
  state: string;
  status: string;
  store_currency_code: string;
  store_id: string;
  store_name: string;
  store_to_base_rate: number;
  store_to_order_rate: number;
  subtotal: number;
  subtotal_incl_tax: number;
  tax_amount: number;
  total_due: number;
  total_item_count: number;
  total_qty_ordered: number;
  updated_at: string;
  weight: number;
  x_forwarded_for: string;

  items: MagentoSalesOrderItems[];

  billing_address: {
    address_type: string;
    city: string;
    country_id: string;
    email: string;
    entity_id: number;
    firstname: string;
    lastname: string;
    parent_id: number;
    postcode: string;
    street: string;
    telephone: string;
  };
  payment: {
    account_status: string;
    additional_information: string;
    amount_authorized: number;
    amount_ordered: number;
    base_amount_authorized: number;
    base_amount_ordered: number;
    base_shipping_amount: number;
    cc_exp_year: string;
    cc_last4: string;
    cc_ss_start_month: string;
    cc_ss_start_year: string;
    entity_id: number;
    last_trans_id: string;
    method: string;
    parent_id: number;
    shipping_amount: number;
  };
  status_histories: MagentoSalesOrderStatusHistory[];
  extension_attributes: {
    shipping_assignments: {
      shipping: {
        address: {
          address_type: string;
          city: string;
          country_id: string;
          email: string;
          entity_id: number;
          firstname: string;
          lastname: string;
          parent_id: number;
          postcode: string;
          street: string;
          telephone: string;
        };
        method: string;
        total: {
          base_shipping_amount: number;
          base_shipping_discount_amount: number;
          base_shipping_discount_tax_compensation_amnt: number;
          base_shipping_incl_tax: number;
          base_shipping_tax_amount: number;
          shipping_amount: number;
          shipping_discount_amount: number;
          shipping_discount_tax_compensation_amount: number;
          shipping_incl_tax: number;
          shipping_tax_amount: number;
        };
      };
      salesOrderItemValue: MagentoSalesOrderItemValues[];
    };

    payment_method: string;
  };
}
